export default {
    loaded: "lootbox.loaded",
    box: {
        loaded: "lootbox.box.loaded",
        update: "lootbox.box.update"
    },
    toggleButton: "lootbox.toggle.button"
}